import { render, staticRenderFns } from "./EditAbsence.vue?vue&type=template&id=531f06d0&scoped=true"
import script from "./EditAbsence.vue?vue&type=script&lang=js"
export * from "./EditAbsence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531f06d0",
  null
  
)

export default component.exports